'use client';

export { EntityReferenceView } from '@agentteams/runner-request/ui/lib/tiptap/extensions/EntityReferenceView';
export { entityConfig } from '@agentteams/runner-request/ui/lib/tiptap/extensions/EntityReferenceView';
export { buildEntityGoHref as buildEntityReferenceGoHref } from '../../entityGoLink';
